import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  LinearProgress,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
  DialogTitle,
  Autocomplete
} from "@mui/material";
import { useFormik } from "formik";
import {
  useCreateCustomerMutation,
  useCreateWorkOrderMutation,
  useCreateBillMutation,
  useGetAllSearchCompanyQuery,
  useGetCompanyQuery,
  useGetCustomerQuery,
  useGetVendorQuery,
  useGetLastBillIdQuery,
  useGetBillPriceHistoryQuery,
  useGetProductQuery,
  useGetTaxQuery,
  useGetInventoryQuery,
  useLazyGetProductSuppliersQuery,
  useLazyGetSupplierProductsQuery,
  useLinkProductToSupplierMutation,
  useGetWarehouseAlertsQuery,
  useReceiveStockMutation,
  useGetWarehouseForecastDataMutation,
} from "../../../Api/attoDeskApi";
import { useNotifier } from "../../../Core/Notifier";
import { useNavigate } from "react-router";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import SearchIcon from "@mui/icons-material/Search";
import {
  ICompanyDetails,
  IPriceHistoryPayload,
  IProductPopUP,
  ITaxes,
  IVendor,
  IProductInventory
} from "../../../Api/Interface/api.interface";
import {
  validateEmail,
  validatePhoneNumber,
} from "../../../Components/Validation/validationUtils";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import {
  ProductType,
  TransferType,
  POStatus,
  POStatusLabels,
  POStatusColors,
} from "../../../Core/Enum/enum";
import AddIcon from "@mui/icons-material/Add";
import { FaTrash } from "react-icons/fa";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import InventoryIcon from "@mui/icons-material/Inventory";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import NewCompanyPopUp from "../../CompanyInfo/Components/NewCompanyPopUp";
import NewCustomerPopUp from "../../Vendor/Components/NewPopUpCustomer";

import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { uploadImage } from "../../../Components/UploadFile/upload";
import { FaEdit } from "react-icons/fa";
import placeholderImage from '../../../Images/fav.png';
import { useParams } from "react-router-dom";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { createFilterOptions } from '@mui/material/Autocomplete';
dayjs.extend(utc);
dayjs.extend(timezone);


const generateWorkOrderNumber = (workOrderId: number) => {
  const date = new Date();
  const year = date.getFullYear().toString().slice(2);
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `PO${year}${month}${day}-${workOrderId.toString().padStart(2, "0")}`;
};

interface IProduct {
  productName: string;
  productDescription: string;
  productImg: String | null;
  numberOfPassengers: number | null;
  transferType: string;
  transferTypeFrom: string;
  transferTypeTo: string;
  transferTypeDescription: string;
  departureDateTime: Dayjs | null;
  returnDateTime: Dayjs | null;
  departureAddress: string;
  destinationAddress: string;
  multiDestination: string;
  quantity: number | null;
  price: number | null;
  sellingPrice: number | null;
  offerPrice: number | null;
  tax: number;
  taxAmount: number;
  total: number;
  taxId: number | null;
  unitPriceWithDiscount: number | null;
  unitTotalWithDiscount: number;
  productType: string;
  productLongDescription: string;
  productShortDescription: string;
  isSerialize: boolean;
  productId: string;
  serializedItems?: ISerializedItem[];
  avgBuyPrice: number;
  supplierUnit: string;
  supplierPrice: number;
  // Conversion & receiving fields
  conversionFactor: number;
  baseUnit: string;
  baseQtyTotal: number;
  receivedQty: number;
  supplierLinked: boolean;
}

interface ISerializedItem {
  serialNo: string;
  imei: string;
  modelNo: string;
  notes: string;
}


interface IDiscount {
  value: number | null;
  description: string;
}

interface IProduct {
  productName: string;
  transferTypeTo: string;
  transferTypeFrom: string;
}

const Index: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [newTax, { isLoading }] = useCreateBillMutation();
  const [triggerGetProductSuppliers] = useLazyGetProductSuppliersQuery();
  const [triggerGetSupplierProducts] = useLazyGetSupplierProductsQuery();
  const [linkProductToSupplier] = useLinkProductToSupplierMutation();
  const { data: reorderAlertsData } = useGetWarehouseAlertsQuery();
  const [receiveStockMutation, { isLoading: isReceiving }] = useReceiveStockMutation();
  const [triggerForecast] = useGetWarehouseForecastDataMutation();
  const [receiveDialogOpen, setReceiveDialogOpen] = useState(false);
  const [aiSuggestLoading, setAiSuggestLoading] = useState(false);
  const { showErrorMessage, showMessage } = useNotifier();

  // const [searchQuery, setSearchQuerffy] = useState<string>("");
   const [currentSearchQuery, setCurrentSearchQuery] = useState<string>("");
  // const debouncedSearchQuery = useDebounce(searchQuery, 300);
  // const [showDropdown, setShowDropdown] = useState<boolean>(false);

  const [searchQueryCustomer, setSearchQueryCustomer] = useState<string>("");
  const [currentSearchQueryCustomer, setCurrentSearchQueryCustomer] =
    useState<string>("");
    
  const debouncedSearchQueryCustomer = useDebounce(searchQueryCustomer, 300);
  const [showDropdownCustomer, setShowDropdownCustomer] =
    useState<boolean>(false);

  const [searchQueryProduct, setSearchQueryProduct] = useState<string>("");
  const [currentSearchQueryProduct, setCurrentSearchQueryProduct] =
    useState<string>("");
  const debouncedSearchQueryProduct = useDebounce(searchQueryProduct, 300);
  const [showDropdownProductIndex, setShowDropdownProductIndex] = useState<
    number | null
  >(null);

  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [isImageUploading, setIsImageUploading] = useState(false);

  const [selectedDefultCompanyId, setSelectedDefultCompanyId] =
    useState<string>("");

  const [averagePrice, setAveragePrice] = useState<number | null>(null);
  const [nextPrice, setNextPrice] = useState<number | null>(null);
  const [quoteWorkOrderNo, setQuoteWorkOrderNo] = useState<String | null>(null);
  const [updated_at, setUpdated_at] = useState<Date | null>(null);
  const [priceId, setPriceId] = useState<number | null>(null);

  const [currentPriceQueryParams, setCurrentPriceQueryParams] =
    useState<IPriceHistoryPayload | null>(null);

  const [currentIndex, setCurrentIndex] = useState<number | null>(null);
   const [popupOpen, setPopupOpen] = useState(false);
    const [editIndex, setEditIndex] = useState<number | null>(null);
    const [editingIndex, setEditingIndex] = useState<number | null>(null);

    const [originalProduct, setOriginalProduct] = useState<IProduct | null>(null); 
    const { id: customerId } = useParams<{ id: string }>();
    const [selectedCustomer, setSelectedCustomer] = useState<IVendor | null>(null);
    const [customerIdToSelect, setCustomerIdToSelect] = useState<string | null>(null);
    const [showCustomerError, setShowCustomerError] = React.useState(false);

    // Supplier-linked product IDs + data
    const [supplierProductIds, setSupplierProductIds] = useState<Set<number>>(new Set());
    const [supplierProductMap, setSupplierProductMap] = useState<Record<number, { supplier_price: number; supplier_unit: string; unit_conversion: string }>>({});
    const [supplierProductsLoading, setSupplierProductsLoading] = useState(false);
    const [supplierOnlyMode, setSupplierOnlyMode] = useState(false);

    // Link product modal
    const [linkModalOpen, setLinkModalOpen] = useState(false);
    const [linkProduct, setLinkProduct] = useState<{ id: string; name: string; index: number } | null>(null);
    const [linkForm, setLinkForm] = useState({ supplier_price: 0, supplier_unit: "", unit_conversion: "" });
    const [linkSaving, setLinkSaving] = useState(false);

  const handleImageChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
      const maxSize = 2048 * 1024; // 2 MB

      if (!validTypes.includes(file.type)) {
        showErrorMessage("The file must be an image (jpeg, png, jpg, gif).");
        return;
      } else if (file.size > maxSize) {
        showErrorMessage("The file must be smaller than 2 MB.");
        return;
      } else {
        try {
          setIsImageUploading(true);
          const uploadedImageUrl = await uploadImage(file);
          const updatedRows = [...productRows];
          updatedRows[index].productImg = uploadedImageUrl;
          setProductRows(updatedRows);
          setIsImageUploading(false);
        } catch (error) {
          showErrorMessage("Failed to upload the image.");
          setIsImageUploading(false);
        }
      }
    }
  };

  const { data: taxData, isLoading: taxLoading } = useGetTaxQuery({
    searchText: "",
  });

  const taxList = useMemo(() => {
    return taxData?.data as ITaxes[];
  }, [taxData?.data]);

  // const defaultTax = useMemo(() => {
  //   const foundDefaultTax = taxList.find((tax) => tax.isDefault === true);
  //   return foundDefaultTax ? foundDefaultTax : taxList[0] || null;
  // }, [taxList]);

 
const emptyProductRow: IProduct = {
  productName: "",
  isSerialize: false,
  productId: "",
  productDescription: "",
  productImg: "",
  numberOfPassengers: null,
  transferType: TransferType.OneWayTransfer,
  transferTypeFrom: "",
  transferTypeTo: "",
  transferTypeDescription: "",
  departureDateTime: null,
  returnDateTime: null,
  departureAddress: "",
  destinationAddress: "",
  multiDestination: "",
  quantity: null,
  price: null,
  sellingPrice: null,
  offerPrice: null,
  tax: 0,
  taxAmount: 0,
  total: 0,
  taxId: 1,
  unitPriceWithDiscount: null,
  unitTotalWithDiscount: 0,
  productType: ProductType.Service,
  productLongDescription: "",
  productShortDescription: "",
  avgBuyPrice: 0,
  supplierUnit: "",
  supplierPrice: 0,
  conversionFactor: 1,
  baseUnit: "unit",
  baseQtyTotal: 0,
  receivedQty: 0,
  supplierLinked: false,
};

const [productRows, setProductRows] = useState<IProduct[]>([{ ...emptyProductRow }]);

 
   const [discounts, setDiscounts] = useState<IDiscount[]>([]);
  const [discountValue, setDiscountValue] = useState<number>(0);
  const [discountDescription, setDiscountDescription] = useState<string>("");
  const [subTotal, setSubTotal] = useState<number>(0);
  const [totalDiscount, setTotalDiscount] = useState<number>(0);
  const [grandTotal, setGrandTotal] = useState<number>(0);
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [unitPrice, setUnitPrice] = useState<number>(0);
  const [grandTotalEithDiscount, setGrandTotalWithDiscount] =
    useState<number>(0);

  const [selectedCompanyLogo, setSelectedCompanyLogo] = useState<string | null>(
    null
  );
  const [openCompany, setOpenCompany] = useState(false);
  const [openCustomer, setOpenCustomer] = useState(false);
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;

  // Fetch supplier's linked products when supplier changes (via RTK Query)
  const loadSupplierProducts = useCallback(async () => {
    if (!selectedCustomer?.id) { setSupplierProductIds(new Set()); setSupplierProductMap({}); return; }
    setSupplierProductsLoading(true);
    try {
      const result = await triggerGetSupplierProducts(String(selectedCustomer.id)).unwrap();
      if (result?.data && Array.isArray(result.data)) {
        const ids = new Set<number>();
        const map: Record<number, any> = {};
        (result.data as any[]).forEach((sp: any) => {
          const pid = Number(sp.product_id);
          ids.add(pid);
          map[pid] = { supplier_price: sp.supplier_price || 0, supplier_unit: sp.supplier_unit || "", unit_conversion: sp.unit_conversion || "" };
        });
        setSupplierProductIds(ids);
        setSupplierProductMap(map);
      } else { setSupplierProductIds(new Set()); setSupplierProductMap({}); }
    } catch { setSupplierProductIds(new Set()); setSupplierProductMap({}); }
    finally { setSupplierProductsLoading(false); }
  }, [selectedCustomer?.id, triggerGetSupplierProducts]);

  useEffect(() => { loadSupplierProducts(); }, [loadSupplierProducts]);

  const {
    data: companyData,
    isLoading: companyIsLoading,
    isError,
    refetch,
  } = useGetCompanyQuery({
    searchText: "",
    id: "",
  });

  const { data: workOrderLastData, isLoading: workOrderIsLoading } =
    useGetLastBillIdQuery();

  const {
    data: vendorData,
    isLoading: vendorIsLoading,
    isError: vendorError,
    refetch: vendorRefetch,
  } = useGetVendorQuery({
    searchText: currentSearchQueryCustomer,
    id: "",
  });

  const {
    data: productData,
    isLoading: productIsLoading,
    refetch: productRefetch,
  } = useGetProductQuery({
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    searchText: "",
    createdDate: null,
    id: null,
  });

  const initialParams: IPriceHistoryPayload = {
    productName: "",
    transferTypeFrom: "",
    transferTypeTo: "",
  };

    const { data: inventoryData, isLoading: invntoryLoading, isError: inventoryError, refetch: inventoryRefecth } = useGetInventoryQuery({
      searchText: currentSearchQuery,
      id: "",
    });

      const inventoryList: IProductInventory[] = Array.isArray(inventoryData?.data)
    ? (inventoryData?.data as IProductInventory[])
    : [];

  const {
    data: priceHistoryData,
    isLoading: priceHistoryIsLoading,
    isError: priceHistoryError,
    refetch: priceHistoryRefetch,
  } = useGetBillPriceHistoryQuery(
    currentPriceQueryParams ? currentPriceQueryParams : initialParams,
    {
      skip: false,
    }
  );

  const companyList: ICompanyDetails[] = Array.isArray(companyData?.data)
    ? (companyData?.data as ICompanyDetails[])
    : [];

  const rawData = workOrderLastData?.data;
  const workOrderId =
    typeof rawData === "number"
      ? rawData
      : parseInt(rawData as string, 10) || 0;

  useEffect(() => {
    if (
      priceHistoryData &&
      Array.isArray(priceHistoryData.data) &&
      priceHistoryData.data.length > 0
    ) {
      setAveragePrice(priceHistoryData.data[0]?.averagePrice || null);
      setNextPrice(priceHistoryData.data[0]?.price || null);
      setQuoteWorkOrderNo(priceHistoryData.data[0]?.quoteWorkOrderNo || null);
      setUpdated_at(priceHistoryData.data[0]?.updated_at || null);
      setPriceId(priceHistoryData.data[0]?.workOrderId || null);
    } else {
      setAveragePrice(null);
      setNextPrice(null);
      setQuoteWorkOrderNo(null);
      setUpdated_at(null);
      setPriceId(null);
    }
  }, [priceHistoryData]);

  const generatedWorkOrderNo = generateWorkOrderNumber(workOrderId);

  // useEffect(() => {
  //   if (debouncedSearchQuery.length >= 0 || debouncedSearchQuery === "") {
  //     setCurrentSearchQuery(debouncedSearchQuery);
  //     refetch();
  //   }
  // }, [debouncedSearchQuery, refetch]);

  // const handleFocusOrClick = () => {
  //   setShowDropdown(true);
  //   if (currentSearchQuery === "") {
  //     refetch();
  //   }
  // };

  const handleFocusOrClickCustomer = () => {
    setShowDropdownCustomer(true);
    if (currentSearchQueryCustomer === "") {
      refetch();
    }
  };

  useEffect(() => {
    if (
      debouncedSearchQueryCustomer?.length >= 2 ||
      debouncedSearchQueryCustomer === ""
    ) {
      setCurrentSearchQueryCustomer(debouncedSearchQueryCustomer);
      vendorRefetch();
    }
  }, [debouncedSearchQueryCustomer, vendorRefetch]);

  useEffect(() => {
    setCurrentSearchQueryProduct(debouncedSearchQueryProduct);
    productRefetch();
  }, [debouncedSearchQueryProduct, productRefetch]);

  // useEffect(() => {
  //   const totalSubTotal = productRows.reduce((acc, row) => acc + row.total, 0);
  //   setSubTotal(totalSubTotal);

  //   const calculatedTotalDiscount = discounts.reduce(
  //     (acc, discount) => acc + (discount.value),
  //     0
  //   );
  //   setTotalDiscount(calculatedTotalDiscount);

  //   const totalGrandTotal = totalSubTotal - calculatedTotalDiscount;
  //   setGrandTotal(totalGrandTotal);
  // }, [productRows, discounts]);

  useEffect(() => {
    const totalSubTotal = productRows.reduce((acc, row) => {
      return acc + ((row.price ?? 0) * (row.quantity ?? 0));
    }, 0);
    setSubTotal(totalSubTotal);

    const calculatedTotalDiscount = discounts.reduce(
      (acc, discount) => acc + (discount.value ?? 0),
      0
    );
    setTotalDiscount(calculatedTotalDiscount);

    const totalGrandTotal = totalSubTotal - calculatedTotalDiscount;
    setGrandTotal(totalGrandTotal);
    setGrandTotalWithDiscount(totalGrandTotal);
  }, [productRows, discounts]);

  const productList: IProductPopUP[] = Array.isArray(productData?.data)
    ? (productData?.data as IProductPopUP[])
    : [];
  const directProductList: IProductPopUP[] = productList; // alias for compatibility

  // Filter product list by search text + supplier mode
  const filteredProductList = useMemo(() => {
    if (!productRows || showDropdownProductIndex === null) return productList;
    const searchText = (productRows[showDropdownProductIndex]?.productName || "").toLowerCase().trim();
    let list = searchText ? productList.filter(p => p.productName.toLowerCase().includes(searchText)) : [...productList];
    console.log("Product filter:", { total: productList.length, afterSearch: list.length, supplierIds: supplierProductIds.size, supplierOnlyMode });
    // Filter or sort by supplier
    if (supplierProductIds.size > 0) {
      if (supplierOnlyMode) {
        const before = list.length;
        list = list.filter(p => supplierProductIds.has(Number(p.id)));
        console.log("Supplier filter:", before, "->", list.length, "ids:", Array.from(supplierProductIds));
      } else {
        list.sort((a, b) => {
          const aL = supplierProductIds.has(Number(a.id)) ? 0 : 1;
          const bL = supplierProductIds.has(Number(b.id)) ? 0 : 1;
          return aL - bL;
        });
      }
    }
    return list;
  }, [productList, showDropdownProductIndex, productRows, supplierProductIds, supplierOnlyMode]);

  // Close dropdown on outside click — use a stable ref
  const dropdownContainerRef = useRef<HTMLTableCellElement | null>(null);

  const customerList: IVendor[] = Array.isArray(vendorData?.data)
    ? (vendorData?.data as IVendor[])
    : [];

    useEffect(() => {
      if (customerId && customerList.length > 0) {
        handleSelectCustomer(customerId);
      }
    }, [customerId, customerList]);

        useEffect(() => {
      if (customerIdToSelect && customerList.length > 0) {
        const found = customerList.find(c => String(c.id) === customerIdToSelect);
        if (found) {
          handleSelectCustomer(customerIdToSelect);
          setCustomerIdToSelect(null); // cleanup
        }
      }
    }, [customerList, customerIdToSelect]);
    

  const today = dayjs();

  // Highlight a row briefly after merge
  const [highlightRow, setHighlightRow] = useState<number | null>(null);
  useEffect(() => { if (highlightRow !== null) { const t = setTimeout(() => setHighlightRow(null), 1500); return () => clearTimeout(t); } }, [highlightRow]);

  const handleProductSelect = async (product: IProductPopUP, index: number) => {
    const pid = Number(product.id);

    // ── STEP 1: DUPLICATE CHECK ──
    const existingIndex = productRows.findIndex((r, i) => i !== index && String(r.productId) === String(product.id) && r.productName);
    if (existingIndex !== -1) {
      // Merge: increase qty on existing row, remove the current empty row
      const updated = [...productRows];
      const existingQty = updated[existingIndex].quantity || 0;
      updated[existingIndex].quantity = existingQty + 1;
      const price = updated[existingIndex].price || 0;
      const conv = updated[existingIndex].conversionFactor || 1;
      updated[existingIndex].total = price * (existingQty + 1);
      updated[existingIndex].unitTotalWithDiscount = updated[existingIndex].total;
      updated[existingIndex].baseQtyTotal = (existingQty + 1) * conv;

      // Remove the row that triggered the select (if it's empty)
      if (!productRows[index].productName || productRows[index].productName === product.productName) {
        updated.splice(index, 1);
      }
      setProductRows(updated);
      setShowDropdownProductIndex(null);
      setHighlightRow(existingIndex > index ? existingIndex - 1 : existingIndex);
      showMessage(`${product.productName} — quantity merged`);
      return;
    }

    // ── STEP 2: NEW PRODUCT — fill row ──
    const updatedRows = [...productRows];
    updatedRows[index].productName = product.productName;
    updatedRows[index].productImg = product.productImg || "";
    updatedRows[index].isSerialize = product.isSerialize || false;
    updatedRows[index].productId = product.id;
    updatedRows[index].sellingPrice = Number(product.salePrice);
    updatedRows[index].offerPrice = Number(product.offerPrice);

    const inventoryRow = inventoryList?.find((inv: any) => inv.productId === product.id);
    updatedRows[index].avgBuyPrice = inventoryRow?.avgBuyPrice || 0;

    // ── STEP 3: AUTO-FILL SUPPLIER DATA ──
    const localMapping = supplierProductMap[pid];
    let priceFound = false;

    if (localMapping) {
      // Instant fill from local map
      updatedRows[index].supplierPrice = localMapping.supplier_price || 0;
      updatedRows[index].supplierUnit = localMapping.supplier_unit || "";
      updatedRows[index].price = localMapping.supplier_price || 0;
      updatedRows[index].supplierLinked = true;
      const convFactor = parseFloat(localMapping.unit_conversion) || 1;
      updatedRows[index].conversionFactor = convFactor;
      updatedRows[index].baseUnit = convFactor > 1 ? "base unit" : (localMapping.supplier_unit || "unit");
      priceFound = localMapping.supplier_price > 0;
    } else {
      // Fallback: API lookup
      try {
        const supplierResult = await triggerGetProductSuppliers(String(product.id)).unwrap();
        if (supplierResult?.data && Array.isArray(supplierResult.data) && supplierResult.data.length > 0) {
          const defaultSupplier = supplierResult.data.find((sp: any) => sp.is_default) || supplierResult.data[0];
          updatedRows[index].supplierPrice = defaultSupplier.supplier_price || 0;
          updatedRows[index].supplierUnit = defaultSupplier.supplier_unit || "";
          updatedRows[index].price = defaultSupplier.supplier_price || 0;
          updatedRows[index].supplierLinked = false;
          const convFactor = parseFloat(defaultSupplier.unit_conversion) || 1;
          updatedRows[index].conversionFactor = convFactor;
          priceFound = defaultSupplier.supplier_price > 0;
        } else {
          updatedRows[index].supplierLinked = false;
        }
      } catch {
        updatedRows[index].supplierLinked = false;
      }
    }

    // ── STEP 4: FALLBACK — use product cost if no supplier price ──
    if (!priceFound) {
      const fallbackPrice = Number(product.productPrice || product.wholesaleprice || 0);
      if (fallbackPrice > 0) {
        updatedRows[index].price = fallbackPrice;
      }
    }

    // Set default qty = 1 for new products
    if (!updatedRows[index].quantity || updatedRows[index].quantity === 0) {
      updatedRows[index].quantity = 1;
    }

    // Recalculate totals
    const qty = updatedRows[index].quantity || 0;
    const unitPrice = updatedRows[index].price || 0;
    const conv = updatedRows[index].conversionFactor || 1;
    updatedRows[index].total = unitPrice * qty;
    updatedRows[index].unitTotalWithDiscount = updatedRows[index].total;
    updatedRows[index].baseQtyTotal = qty * conv;

    // ── STEP 5: VALIDATION WARNING ──
    if (!updatedRows[index].price || (updatedRows[index].price ?? 0) <= 0) {
      showErrorMessage(`No supplier price found for ${product.productName}. Please enter manually.`);
    }

    setProductRows(updatedRows);
    setShowDropdownProductIndex(null);
    setHighlightRow(index);
  };

  const handleAddRow = () => {
    // Validate existing rows before adding new one
    const filledRows = productRows.filter(r => !!r.productId || !!r.productName);
    if (filledRows.length > 0 && hasRowErrors) {
      setShowRowErrors(true);
      showErrorMessage("Complete existing items before adding new ones");
      return;
    }
    setEditIndex(null);
    setProductRows((prev) => [...prev, { ...emptyProductRow }]);
    setSearchQueryProduct("");
    setShowRowErrors(false);
  };
 
   const handlePriceChange = (index: number, newPrice: number) => {
    const updatedRows = [...productRows];
    const product = updatedRows[index];
    const quantity = product.quantity || 0;
    product.price = newPrice;

    // Total = qty × unit cost
    product.total = newPrice * quantity;
    product.unitTotalWithDiscount = newPrice * quantity;

    setProductRows(updatedRows);
  };
 
   const handleCancel = () => {
     if (editIndex !== null && originalProduct) {
       // Log the original product row before canceling
       console.log("Reverting to the original product row:", originalProduct);
   
       // Revert to the original product data (before editing)
       setProductRows(prevRows => {
         const updatedRows = [...prevRows];
         updatedRows[editIndex] = originalProduct; // Restore the original row
         return updatedRows;
       });
   
     
       setEditIndex(null);    // Clear edit index
       setOriginalProduct(null);  // Clear original product data after canceling
     } else {
       // If no row is being edited, just close the popup and remove the last empty row if necessary
       const lastRow = productRows[productRows.length - 1];
       if (
         !lastRow?.productName ||
         !lastRow?.productDescription ||
         !lastRow?.price ||
         !lastRow?.sellingPrice ||
         !lastRow?.offerPrice ||
         (lastRow?.tax && lastRow?.tax <= 0)
       ) {
         console.log("Removing last row because it's empty or invalid");
         setProductRows(productRows.slice(0, productRows.length - 1));
       }
     }
     setPopupOpen(false);  // Close the popup
   };
  // const handleFieldChange = <K extends keyof IProduct>(
  //   index: number,
  //   field: K,
  //   value: IProduct[K]
  // ) => {
  //   const updatedRows = [...productRows];
  //   updatedRows[index][field] = value;

  //   updatedRows[index].total =
  //     updatedRows[index].price *
  //     updatedRows[index].quantity *
  //     (1 + updatedRows[index].tax / 100);

  //   setProductRows(updatedRows);
  // };

  // const handleFieldChange = <K extends keyof IProduct>(
  //   index: number,
  //   field: K,
  //   value: IProduct[K]
  // ) => {
  //   const updatedRows = [...productRows];
  //   updatedRows[index][field] = value;

  //   const price = updatedRows[index].price ?? 0;
  //   const quantity = updatedRows[index].quantity ?? 0;
  //   const tax = updatedRows[index].tax ?? 0;

  //   updatedRows[index].total = price * quantity * (1 + tax / 100);

  //   setProductRows(updatedRows);
  // };

  const handleFieldChange = <K extends keyof IProduct>(
    index: number,
    field: K,
    value: IProduct[K]
  ) => {
    const updatedRows = [...productRows];
    updatedRows[index][field] = value;

    const price = updatedRows[index].price ?? 0;
    const quantity = updatedRows[index].quantity ?? 0;
    const convFactor = updatedRows[index].conversionFactor ?? 1;

    // Total = qty × unit cost
    updatedRows[index].total = price * quantity;
    updatedRows[index].unitTotalWithDiscount = price * quantity;
    // Base quantity = supplier qty × conversion factor
    updatedRows[index].baseQtyTotal = quantity * convFactor;

    setProductRows(updatedRows);

    if (
      updatedRows[index].productName &&
      updatedRows[index].transferTypeFrom &&
      updatedRows[index].transferTypeTo
    ) {
      updatePriceQueryParams(updatedRows[index]);
      setCurrentIndex(index);
    }
  };

  const updatePriceQueryParams = (row: IProduct) => {
    const { productName, transferTypeFrom, transferTypeTo } = row;

    if (productName && transferTypeFrom && transferTypeTo) {
      const newParams: IPriceHistoryPayload = {
        productName,
        transferTypeFrom,
        transferTypeTo,
      };

      setCurrentPriceQueryParams(newParams);

      if (newParams) {
        priceHistoryRefetch();
      }
    } else {
      console.error("Incomplete parameters for price query.");
    }
  };

  useEffect(() => {
    const totalSubTotal = productRows.reduce((acc, row) => {
      const price = row.price ?? 0;
      const quantity = row.quantity ?? 0;
      return acc + (price * quantity);
    }, 0);
    setSubTotal(totalSubTotal);

    const calculatedTotalDiscount = discounts.reduce(
      (acc, discount) => acc + (discount.value ?? 0),
      0
    );
    setTotalDiscount(calculatedTotalDiscount);

    const grandTotalValue = totalSubTotal - calculatedTotalDiscount;
    setGrandTotalWithDiscount(grandTotalValue);
  }, [productRows, discounts]);

  const handleProductNameChange = (index: number, value: string) => {
    setSearchQueryProduct(value);
    handleFieldChange(index, "productName", value);
  };

  const handleDeleteRow = (index: number) => {
    // const updatedRows = productRows.filter((_, i) => i !== index);
     const updatedRows = [...productRows];
     updatedRows.splice(index, 1);
     setProductRows(updatedRows);
    // console.log(updatedRows)
   };

   const handleEditRow = (index: number) => {
    const productToEdit = productRows[index];
    setOriginalProduct({ ...productToEdit });
    setEditIndex(index);
    setPopupOpen(true);
    //console.log("Editing product: ", productToEdit);

  };

     const filterOptions = createFilterOptions({
      matchFrom: 'any', // Match anywhere in the string
      stringify: (option: any) => {
        if (typeof option === 'string') return option;
        // Combine fields for searching
        return `${option.customerFirstName} ${option.customerLastName} ${option.customerMobileNum}`;
      },
    });

     const handleNewCustomerAdded = (newCustomer: any) => {
  vendorRefetch();
  const name = newCustomer.customerCompanyName?.trim() || `${newCustomer.customerFirstName || ""} ${newCustomer.customerLastName || ""}`;
  setSelectedCustomer(newCustomer);
  setSearchQueryCustomer(name);
  setShowCustomerError(false);
  // Fill formik fields
  formik.setFieldValue("customerCompanyName", newCustomer.customerCompanyName || "");
  formik.setFieldValue("customerFirstName", newCustomer.customerFirstName || "");
  formik.setFieldValue("customerLastName", newCustomer.customerLastName || "");
  formik.setFieldValue("customerMobileNum", newCustomer.customerMobileNum || newCustomer.customerCompanyPhoneNumebr || "");
  formik.setFieldValue("customerEmail", newCustomer.customerEmail || "");
  formik.setFieldValue("quoteWorkOrderCustomerId", newCustomer.id);
  setCustomerIdToSelect(String(newCustomer.id));
};



  const handleDiscountChange = (
    index: number,
    field: keyof IDiscount,
    value: any
  ) => {
    const updatedDiscounts = [...discounts];
    updatedDiscounts[index] = {
      ...updatedDiscounts[index],
      [field]: value,
    };
    setDiscounts(updatedDiscounts);
  };

  const handleOpenDialog = (index: number | null) => {
    if (index !== null) {
      // Editing existing discount
      const discountToEdit = discounts[index];
      setDiscountValue(discountToEdit.value ?? 0);
      setDiscountDescription(discountToEdit.description);
      setEditingIndex(index); // Set the index of the item being edited
    } else {
      // Adding a new discount
      setDiscountValue(0);
      setDiscountDescription("");
      setEditingIndex(null); // Reset editing index
    }
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setDiscountValue(0);
    setDiscountDescription("");
    setEditingIndex(null);
  };
  const handleSaveDiscount = () => {
    if (editingIndex !== null) {
      // Update existing discount
      const updatedDiscounts = discounts.map((discount, index) =>
        index === editingIndex
          ? { value: discountValue, description: discountDescription }
          : discount
      );
      setDiscounts(updatedDiscounts);
    } else {
      // Add a new discount
      setDiscounts((prev) => [
        ...prev,
        { value: discountValue, description: discountDescription },
      ]);
    }
    handleCloseDialog();
  };

  const handleDeleteDiscount = (index: number) => {
    const updatedDiscounts = discounts.filter((_, i) => i !== index);
    setDiscounts(updatedDiscounts);
  };

  const formik = useFormik({
    initialValues: {
      companyName: "",
      companyLogo: "",
      companyProvince: "",
      companyCity: "",
      companyPostalCode: "",
      companyStreetNumber: "",
      companyStreetName: "",
      companyMobileNumber: "",
      companyEmail: "",
      companyAddress: "",
      quoteWorkOrderNo: "",
      quoteWorkOrderIssueDate: null,
      quoteWorkOrderDueDate: null,
      quoteWorkOrderStatus: "",
      customerCompanyName: "",
      customerFirstName: "",
      customerLastName: "",
      customerMobileNum: "",
      customerEmail: "",
      customerProvince: "",
      customerCity: "",
      customerPostalCode: "",
      customerStreetNumber: "",
      customerStreetName: "",
      quoteWorkOrderSale: [],
      quoteWorkOrderSaleDiscount: "",
      quoteWorkOrderSaleSubTotal: "",
      quoteWorkOrderSaleGrandTotal: "",
      quoteWorkOrderSaleDiscountDescription: [],
      quoteWorkOrderCompanyId: "",
      quoteWorkOrderCustomerId: "",
      quoteWorkOrderCustomerRemark: "",
      quoteWorkOrderCustomerMemo: "",
    },

    enableReinitialize: true,
    validate: (values) => {
      const errors: { [key: string]: string } = {};

      const mobileNumberError = validatePhoneNumber(values.companyMobileNumber);
      if (mobileNumberError) {
        errors.companyMobileNumber = mobileNumberError;
      }

      const emailError = validateEmail(values.companyEmail);
      if (emailError) {
        errors.companyEmail = emailError;
      }

      const customerMobileNumberError = validatePhoneNumber(
        values.customerMobileNum
      );
      if (customerMobileNumberError) {
        errors.customerMobileNum = customerMobileNumberError;
      }

      const customerEmailError = validateEmail(values.customerEmail);
      if (customerEmailError) {
        errors.customerEmail = customerEmailError;
      }

      return errors;
    },

    onSubmit: async (values, { resetForm }) => {

     if (!selectedCustomer) {
    setShowCustomerError(true);
    return;
  }
  setShowCustomerError(false);

      // Validate product rows
      if (!validateRows()) return;

      try {
        const temData = {
          companyName: values.companyName,
          companyLogo: values.companyLogo,
          companyProvince: values.companyProvince,
          companyCity: values.companyCity,
          companyPostalCode: values.companyPostalCode,
          companyStreetNumber: values.companyStreetNumber,
          companyStreetName: values.companyStreetName,
          companyMobileNumber: values.companyMobileNumber,
          companyEmail: values.companyEmail,
          companyAddress: values.companyAddress,
          quoteWorkOrderNo: generatedWorkOrderNo,
          quoteWorkOrderIssueDate: values.quoteWorkOrderIssueDate,
          quoteWorkOrderDueDate: values.quoteWorkOrderDueDate,
          quoteWorkOrderStatus: Number(values.quoteWorkOrderStatus),
          customerCompanyName: values.customerCompanyName,
            customerFirstName: values.customerFirstName,
          customerLastName: values.customerLastName,
          customerMobileNum: values.customerMobileNum,
          customerEmail: values.customerEmail,
          customerProvince: values.customerProvince,
          customerCity: values.customerCity,
          customerPostalCode: values.customerPostalCode,
          customerStreetNumber: values.customerStreetNumber,
          customerStreetName: values.customerStreetName,
          quoteWorkOrderSale: productRows,
          quoteWorkOrderDiscount: String(totalDiscount),
          quoteWorkOrderSubTotal: String(subTotal),
          quoteWorkOrderSaleGrandTotal: String(grandTotalEithDiscount),
          quoteWorkOrderSaleDiscountDescription: discounts,
          quoteWorkOrderCompanyId: String(values.quoteWorkOrderCompanyId),
          quoteWorkOrderCustomerId: String(values.quoteWorkOrderCustomerId),
          quoteWorkOrderCustomerRemark: values.quoteWorkOrderCustomerRemark,
          quoteWorkOrderCustomerMemo: values.quoteWorkOrderCustomerMemo,
        };
        console.log("PO Submit payload:", JSON.stringify(temData, null, 2));
        const addCompanyResponse = await newTax(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
         // navigate("/quote/list");
          navigate(-1);
          cancelFunction();
          // loadingFunction();
        }
      } catch (error: any) {
        console.error("PO Save error:", error);
        console.error("Error data:", error?.data);
        console.error("Error message:", error?.data?.message || error?.message);
        showErrorMessage(error?.data?.message || error?.message || "Something went wrong");
      }
    },
  });

  useEffect(() => {
    if (workOrderId !== null) {
      const generatedWorkOrderNo = generateWorkOrderNumber(workOrderId);
      formik.setFieldValue("quoteWorkOrderNo", generatedWorkOrderNo);
       formik.setFieldValue("quoteWorkOrderStatus", POStatus.Draft);
    }
  }, [workOrderId]);

  

  const formatAddress = (
    streetNumber: string,
    streetName: string,
    postalCode: string,
    city: string,
    province: string
  ) => {
    const streetParts = [streetNumber, streetName].filter(Boolean).join(" ");
    const cityLine = [city, province, postalCode].filter(Boolean).join(", ");
    const lines = [streetParts, cityLine].filter(Boolean);
    return lines.join(",\n");
  };

  const customerFormatAddress = (
    streetNumber: string,
    streetName: string,
    city: string,
    province: string,
    postalCode: string,
  ) => {
    const streetParts = [streetNumber, streetName].filter(Boolean).join(" ");
    const cityLine = [city, province, postalCode].filter(Boolean).join(", ");
    const lines = [streetParts, cityLine].filter(Boolean);
    return lines.join(",\n");
  };

  const handleSelect = (companyId: string) => {
    const selectedCompany = companyList.find(
      (company) => String(company.id) === companyId
    );
    
    if (selectedCompany) {
      // setSearchQuery(selectedCompany.companyName);

      const formattedAddress = formatAddress(
        selectedCompany.companyStreetNumber,
        selectedCompany.companyStreetName,
        selectedCompany.companyCity,
        selectedCompany.companyProvince,
        selectedCompany.companyPostalCode,
      );

      formik.setFieldValue("companyName", selectedCompany.companyName);
      formik.setFieldValue("companyProvince", selectedCompany.companyProvince);
      formik.setFieldValue("companyCity", selectedCompany.companyCity);
      formik.setFieldValue(
        "companyPostalCode",
        selectedCompany.companyPostalCode
      );
      formik.setFieldValue(
        "companyStreetNumber",
        selectedCompany.companyStreetNumber
      );
      formik.setFieldValue(
        "companyStreetName",
        selectedCompany.companyStreetName
      );

      formik.setFieldValue(
        "companyMobileNumber",
        selectedCompany.companyMobileNumber
      );

      formik.setFieldValue("companyEmail", selectedCompany.companyEmail);
      formik.setFieldValue("quoteWorkOrderCompanyId", selectedCompany.id);

      formik.setFieldValue("companyAddress", formattedAddress);
      setSelectedCompanyLogo(selectedCompany.CompanyLogo);
    }
  };

  // const defaultCompany = companyList.find(
  //   (company) => company.isDefault === 1
  // );

  // const selectedCompanyConst = defaultCompany || companyList[0];

  useEffect(() => {
    if (companyList && companyList.length > 0) {
      const defaultCompany = companyList.find(
        (company) => company.isDefault === 1
      );

      const selectedCompany = defaultCompany || companyList[0];

      if (selectedCompany) {
        setSelectedDefultCompanyId(String(selectedCompany.id));

        const formattedAddress = formatAddress(
          selectedCompany.companyStreetNumber,
          selectedCompany.companyStreetName,
          selectedCompany.companyPostalCode,
          selectedCompany.companyCity,
          selectedCompany.companyProvince
        );

        formik.setFieldValue("companyName", selectedCompany.companyName);
        formik.setFieldValue(
          "companyProvince",
          selectedCompany.companyProvince
        );
        formik.setFieldValue("companyCity", selectedCompany.companyCity);
        formik.setFieldValue(
          "companyPostalCode",
          selectedCompany.companyPostalCode
        );
        formik.setFieldValue(
          "companyStreetNumber",
          selectedCompany.companyStreetNumber
        );
        formik.setFieldValue(
          "companyStreetName",
          selectedCompany.companyStreetName
        );
        formik.setFieldValue(
          "companyMobileNumber",
          selectedCompany.companyMobileNumber
        );
        formik.setFieldValue("companyEmail", selectedCompany.companyEmail);
        formik.setFieldValue("quoteWorkOrderCompanyId", selectedCompany.id);
        formik.setFieldValue("companyAddress", formattedAddress);
        setSelectedCompanyLogo(selectedCompany.CompanyLogo);
      }
    }
  }, [companyList]);

  const handleSelectCustomer = (customerId: string) => {
    const selectedCustomer = customerList.find(
      (customer) => String(customer.id) === customerId
    );

 

    if (selectedCustomer) {

      const customerFormattedAddress = customerFormatAddress(
         selectedCustomer.customerStreetNumber || "",
        selectedCustomer.customerStreetName || "",
        selectedCustomer.customerCity || "",
        selectedCustomer.customerProvince || "",
        selectedCustomer.customerPostalCode || "",
      );

      setSearchQueryCustomer(
        // (selectedCustomer.customerFirstName || " ") +
        //   " " +
        //   (selectedCustomer.customerLastName || " ")
        selectedCustomer.customerCompanyName
      );

           setSelectedCustomer(selectedCustomer);

      formik.setFieldValue(
        "customerCompanyName",
        selectedCustomer.customerCompanyName || "",
      );
       formik.setFieldValue(
        "customerFirstName",
        selectedCustomer.customerFirstName || ""
      );
      formik.setFieldValue(
        "customerLastName",
        selectedCustomer.customerLastName || ""
      );
      formik.setFieldValue(
        "customerMobileNum",
        selectedCustomer.customerMobileNum|| "",
      );
      formik.setFieldValue("customerEmail", selectedCustomer.customerEmail || "",);
      
      formik.setFieldValue("customerAddress", customerFormattedAddress || "",);
      formik.setFieldValue("quoteWorkOrderCustomerId", selectedCustomer.id);
    }
    setShowDropdownCustomer(false);
  };

  const cancelFunction = () => {
    formik.resetForm();
    setSearchQueryCustomer("");
    setCurrentSearchQueryCustomer("");
    setSearchQueryProduct("");
    setCurrentSearchQueryProduct("");
    setShowDropdownProductIndex(null);
    setDiscountDescription("");
    setSubTotal(0);
    setGrandTotal(0);
    setSelectedCompanyLogo(null);
    setSelectedCustomer(null);
    setProductRows([{ ...emptyProductRow }]);
    setDiscounts([]);
    setTotalDiscount(0);
    setGrandTotalWithDiscount(0);
    navigate("/bill/list");
  };

  // Row validation
  const [showRowErrors, setShowRowErrors] = useState(false);

  const rowErrors = useMemo(() => {
    const errors: Record<number, Record<string, string>> = {};
    productRows.forEach((row, i) => {
      // Skip completely empty rows
      if (!row.productName && !row.productId) return;
      const e: Record<string, string> = {};
      if (!row.productId) e.productId = "Required";
      if (!row.quantity || row.quantity <= 0) e.quantity = "Required";
      if (!row.price || (row.price ?? 0) <= 0) e.price = "Required";
      if (Object.keys(e).length > 0) errors[i] = e;
    });
    return errors;
  }, [productRows]);

  const hasRowErrors = Object.keys(rowErrors).length > 0;
  const hasFilledRows = productRows.some(r => !!r.productId);

  const validateRows = (): boolean => {
    if (hasRowErrors) {
      setShowRowErrors(true);
      showErrorMessage("Please complete all required fields");
      return false;
    }
    if (!hasFilledRows) {
      showErrorMessage("Add at least one product");
      return false;
    }
    return true;
  };

  const formValid = useMemo(() => {
    if (!formik.values.companyName) return false;
    if (formik.values.quoteWorkOrderStatus === "" || formik.values.quoteWorkOrderStatus === undefined || formik.values.quoteWorkOrderStatus === null) return false;
    if (!selectedCustomer) return false;
    if (hasRowErrors && showRowErrors) return false;
    if (!hasFilledRows) return false;
    return true;
  }, [formik.values.companyName, formik.values.quoteWorkOrderStatus, selectedCustomer, hasRowErrors, showRowErrors, hasFilledRows]);

  useEffect(() => {
       const now = dayjs().tz("America/Toronto");
    if (formik.values.quoteWorkOrderIssueDate === null) {
      formik.setFieldValue("quoteWorkOrderIssueDate", now);
    }
    if (formik.values.quoteWorkOrderDueDate === null) {
      formik.setFieldValue("quoteWorkOrderDueDate",  now.add(5, "day"));
    }
  }, [formik.values.quoteWorkOrderIssueDate, formik.values.quoteWorkOrderDueDate]);


  const updateSerial = (
  productIndex: number,
  serialIndex: number,
  field: "serialNo" | "imei" | "modelNo" | "notes",
  value: string
) => {
  setProductRows((prev) => {
    const updated = [...prev];

    // Initialize array if not existing
    if (!updated[productIndex].serializedItems) {
      updated[productIndex].serializedItems = [];
    }

    // Initialize row if empty
    if (!updated[productIndex].serializedItems![serialIndex]) {
      updated[productIndex].serializedItems![serialIndex] = {
        serialNo: "",
        imei: "",
        modelNo: "",
        notes: "",
      };
    }

    updated[productIndex].serializedItems![serialIndex][field] = value;

    return updated;
  });
};



  // useEffect(() => {
  //   if (formik.values.quoteWorkOrderStatus === "") {
  //     if (companyList && companyList.length > 0) {
  //       setSelectedCompanyId(String(companyList[0].id));
  //     }
  //     formik.setFieldValue("quoteWorkOrderStatus", selectedCompanyId);
  //   }
  // }, [formik.values.quoteWorkOrderStatus, companyList]);

  // const loadingFunction = () => {
  //   if (
  //     isLoading ||
  //     taxLoading ||
  //     workOrderIsLoading ||
  //     productIsLoading ||
  //     companyIsLoading ||
  //     customerIsLoading ||
  //     priceHistoryIsLoading
  //   ) {
  //     return (
  //       <Box
  //         display="flex"
  //         justifyContent="center"
  //         alignItems="center"
  //         height="10vh"
  //       >
  //         <CircularProgress />
  //       </Box>
  //     );
  //   }
  // };

  return (
    <Box sx={{ bgcolor: "#fff", minHeight: "100vh" }}>
      {/* ── STICKY TOP BAR ── */}
      <Box sx={{ bgcolor: "#fff", borderBottom: "1px solid #E5E7EB", px: 3, py: 1.5, position: "sticky", top: 0, zIndex: 20 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, width: "100%" }}>
          <SaveAltIcon sx={{ fontSize: 20, color: "#6B7280" }} />
          <Box sx={{ flex: 1 }}>
            <Typography fontSize={15} fontWeight={600} color="#111827">Purchase Order</Typography>
            <Typography fontSize={11} color="#9CA3AF">{formik.values.quoteWorkOrderNo || "New Order"}</Typography>
          </Box>
          <Button variant="outlined" size="small" onClick={cancelFunction}
            sx={{ borderRadius: 1.5, textTransform: "none", fontSize: 13, fontWeight: 500, borderColor: "#D1D5DB", color: "#374151", mr: 1, "&:hover": { bgcolor: "#F9FAFB" } }}>Cancel</Button>
          <Button variant="contained" disableElevation size="small" onClick={() => formik.handleSubmit()} disabled={!formValid || isLoading}
            startIcon={isLoading ? <CircularProgress size={14} sx={{ color: "#fff" }} /> : <SaveAltIcon sx={{ fontSize: 16 }} />}
            sx={{ borderRadius: 1.5, textTransform: "none", fontSize: 13, fontWeight: 600, bgcolor: "#111827", px: 3, "&:hover": { bgcolor: "#1F2937" }, "&.Mui-disabled": { bgcolor: "#E5E7EB", color: "#9CA3AF" } }}>
            {isLoading ? "Saving..." : "Save Order"}
          </Button>
        </Box>
      </Box>

      <Box sx={{ width: "100%", p: 3 }}>
        <form onSubmit={formik.handleSubmit}>
          {/* ── HEADER: PO Info ─────────────────────────────── */}
          <Box sx={{ mb: 3, borderRadius: 2, border: "1px solid #E5E7EB", p: 3 }}>
              <Grid container spacing={3} alignItems="flex-start">
                <Grid item xs={12} md={4}>
                  <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                    <Box sx={{ width: 48, height: 48, borderRadius: 2, bgcolor: "#F9FAFB", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", border: "1px solid #E5E7EB", flexShrink: 0 }}>
                      {selectedCompanyLogo ? (
                        <img src={`${LARAVEL_API_URL}/${selectedCompanyLogo}`} alt="Logo" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                      ) : (
                        <SaveAltIcon sx={{ fontSize: 20, color: "#D1D5DB" }} />
                      )}
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: 12, fontWeight: 500, color: "#6B7280" }}>Purchase Order</Typography>
                      <Typography sx={{ fontSize: 20, fontWeight: 600, color: "#111827", letterSpacing: "-0.02em", lineHeight: 1.2, fontVariantNumeric: "tabular-nums" }}>
                        {formik.values.quoteWorkOrderNo || "—"}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {/* Status */}
                <Grid item xs={12} sm={4} md={2}>
                  <Typography sx={{ fontSize: 12, fontWeight: 500, color: "#6B7280", mb: 0.75 }}>Status</Typography>
                  <TextField select size="small" fullWidth
                    {...formik.getFieldProps("quoteWorkOrderStatus")}
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5, bgcolor: "#fff", "& fieldset": { borderColor: "#E5E7EB" } } }}>
                    <MenuItem value="" disabled>Select</MenuItem>
                    {Object.entries(POStatus).map(([key, value]) => (
                      <MenuItem key={value} value={value}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: POStatusColors[value]?.color }} />
                          {POStatusLabels[value]}
                        </Box>
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* Issue Date */}
                <Grid item xs={6} sm={4} md={2}>
                  <Typography sx={{ fontSize: 12, fontWeight: 500, color: "#6B7280", mb: 0.75 }}>Issue Date</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker value={formik.values.quoteWorkOrderIssueDate} onChange={(date) => formik.setFieldValue("quoteWorkOrderIssueDate", date)}
                      slotProps={{ textField: { size: "small", fullWidth: true, sx: { "& .MuiOutlinedInput-root": { borderRadius: 1.5, bgcolor: "#fff", "& fieldset": { borderColor: "#E5E7EB" } } } } }} />
                  </LocalizationProvider>
                </Grid>

                {/* Due Date */}
                <Grid item xs={6} sm={4} md={2}>
                  <Typography sx={{ fontSize: 12, fontWeight: 500, color: "#6B7280", mb: 0.75 }}>Due Date</Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker value={formik.values.quoteWorkOrderDueDate} onChange={(date) => formik.setFieldValue("quoteWorkOrderDueDate", date)}
                      slotProps={{ textField: { size: "small", fullWidth: true, sx: { "& .MuiOutlinedInput-root": { borderRadius: 1.5, bgcolor: "#fff", "& fieldset": { borderColor: "#E5E7EB" } } } } }} />
                  </LocalizationProvider>
                </Grid>

                {/* Status takes remaining space */}
              </Grid>
          </Box>
          {/* ── SUPPLIER & COMPANY CARDS ──────────────────────────── */}
          <Grid container spacing={3} sx={{ mb: 3 }}>
                {/* Supplier (Issue From) */}
                <Grid item xs={12} md={6}>
                  <Paper elevation={0} sx={{ p: 2.5, border: "1px solid #E5E7EB", borderRadius: 2, height: "100%" }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#3b82f6" }} />
                        <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#111827" }}>Supplier</Typography>
                      </Box>
                      <Button size="small" variant="outlined" onClick={() => setOpenCustomer(true)}
                        sx={{ borderRadius: 2, textTransform: "none", fontSize: 11, fontWeight: 600, borderColor: "#e2e8f0", color: "#64748b", minWidth: "auto", px: 1.5 }}>
                        <AddIcon fontSize="small" />
                      </Button>
                    </Box>

                    <Autocomplete
                      options={customerList}
                      isOptionEqualToValue={(option, value) => Number(option.id) === Number(value.id)}
                      getOptionLabel={(option) => {
                        if (typeof option === 'string') return option;
                        if (option.customerCompanyName?.trim()) return option.customerCompanyName;
                        return `${option.customerFirstName || ''} ${option.customerLastName || ''}`.trim() || `Supplier #${option.id}`;
                      }}
                      filterOptions={createFilterOptions({
                        matchFrom: 'any',
                        stringify: (option: any) => `${option.customerCompanyName || ''} ${option.customerFirstName || ''} ${option.customerLastName || ''} ${option.customerMobileNum || ''}`,
                      })}
                      value={selectedCustomer || null}
                      onChange={(event, newValue) => {
                        if (typeof newValue === 'object' && newValue !== null) {
                          setSelectedCustomer(newValue);
                          handleSelectCustomer(String(newValue.id));
                          setSearchQueryCustomer(newValue.customerCompanyName?.trim() || `${newValue.customerFirstName || ''} ${newValue.customerLastName || ''}`);
                        } else if (typeof newValue === 'string') {
                          setSearchQueryCustomer(newValue);
                          setSelectedCustomer(null);
                          handleSelectCustomer("");
                        }
                      }}
                      onInputChange={(event, newInputValue) => {
                        setSearchQueryCustomer(newInputValue);
                        if (newInputValue === '') setSelectedCustomer(null);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search supplier..."
                          size="small"
                          error={showCustomerError && !selectedCustomer}
                          helperText={showCustomerError && !selectedCustomer ? "Supplier selection is required" : ""}
                          sx={{ mb: 1.5 }}
                        />
                      )}
                      sx={{ mb: 1 }}
                    />

                    {selectedCustomer && (
                      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8, mt: 1, pl: 0.5 }}>
                        <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#1e293b" }}>
                          {formik.values.customerCompanyName?.trim()
                            ? formik.values.customerCompanyName
                            : `${formik.values.customerFirstName || ""} ${formik.values.customerLastName || ""}`}
                        </Typography>
                        {(formik.values as any).customerAddress && (
                          <Typography sx={{ fontSize: 12, color: "#64748b", whiteSpace: "pre-line" }}>
                            {(formik.values as any).customerAddress}
                          </Typography>
                        )}
                        {formik.values.customerMobileNum && (
                          <Typography sx={{ fontSize: 12, color: "#64748b" }}>{formik.values.customerMobileNum}</Typography>
                        )}
                        {formik.values.customerEmail && (
                          <Typography sx={{ fontSize: 12, color: "#64748b" }}>{formik.values.customerEmail}</Typography>
                        )}
                      </Box>
                    )}
                  </Paper>
                </Grid>

                {/* Company (Issue For) */}
                <Grid item xs={12} md={6}>
                  <Paper elevation={0} sx={{ p: 2.5, border: "1px solid #E5E7EB", borderRadius: 2, height: "100%" }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#16a34a" }} />
                        <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#111827" }}>Ship To</Typography>
                      </Box>
                      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                      <TextField
                        select
                        size="small"
                        value={selectedDefultCompanyId}
                        onChange={(event) => {
                          const selectedId = event.target.value;
                          setSelectedDefultCompanyId(selectedId);
                          handleSelect(selectedId);
                        }}
                        sx={{ minWidth: 160, "& .MuiOutlinedInput-root": { borderRadius: 2, fontSize: 13, "& fieldset": { borderColor: "#e2e8f0" } } }}
                      >
                        <MenuItem value="" disabled>Select company</MenuItem>
                        {companyList && companyList.map((company) => (
                          <MenuItem key={company.id} value={String(company.id)}>
                            {company.companyName}
                          </MenuItem>
                        ))}
                      </TextField>
                      <IconButton size="small" onClick={() => setOpenCompany(true)}
                        sx={{ width: 32, height: 32, border: "1px solid #e2e8f0", borderRadius: 2, "&:hover": { bgcolor: "#f8fafc" } }}>
                        <AddIcon sx={{ fontSize: 16, color: "#64748b" }} />
                      </IconButton>
                      </Box>
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.8, pl: 0.5 }}>
                      <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#1e293b" }}>
                        {formik.values.companyName || "—"}
                      </Typography>
                      {formik.values.companyAddress && (
                        <Typography sx={{ fontSize: 12, color: "#64748b", whiteSpace: "pre-line" }}>
                          {formik.values.companyAddress}
                        </Typography>
                      )}
                      {formik.values.companyMobileNumber && (
                        <Typography sx={{ fontSize: 12, color: "#64748b" }}>{formik.values.companyMobileNumber}</Typography>
                      )}
                      {formik.values.companyEmail && (
                        <Typography sx={{ fontSize: 12, color: "#64748b" }}>{formik.values.companyEmail}</Typography>
                      )}
                    </Box>
                  </Paper>
                </Grid>
          </Grid>

            {/* ── PRODUCT TABLE ─────────────────────────────────────── */}
          <Paper elevation={0} sx={{ p: 3, mb: 3, borderRadius: 2, border: "1px solid #E5E7EB" }}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2.5 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#8b5cf6" }} />
                  <Typography sx={{ fontWeight: 600, fontSize: 13, color: "#111827" }}>Order Items</Typography>
                  <Chip size="small" label={`${productRows.filter(r => r.productName).length} items`} sx={{ height: 20, fontSize: 10, fontWeight: 600, bgcolor: "#f1f5f9", color: "#64748b" }} />
                </Box>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="Add products that are below reorder point">
                    <Button variant="outlined" size="small"
                      startIcon={<PlaylistAddIcon sx={{ fontSize: 15 }} />}
                      onClick={() => {
                        const alerts = reorderAlertsData?.data;
                        if (!alerts || !Array.isArray(alerts) || alerts.length === 0) {
                          showErrorMessage("No products need reordering");
                          return;
                        }
                        // Only include supplier-linked products if supplier is selected
                        const filtered = supplierProductIds.size > 0
                          ? (alerts as any[]).filter((a: any) => supplierProductIds.has(Number(a.id)))
                          : alerts;
                        if ((filtered as any[]).length === 0) {
                          showErrorMessage("No linked products need reordering");
                          return;
                        }
                        const newRows: IProduct[] = (filtered as any[]).map((alert: any) => {
                          const mapping = supplierProductMap[Number(alert.id)];
                          return {
                            ...emptyProductRow,
                            productName: alert.productName,
                            productId: String(alert.id),
                            quantity: alert.reorder_qty || 1,
                            baseQtyTotal: (alert.reorder_qty || 1) * (mapping ? parseFloat(mapping.unit_conversion) || 1 : 1),
                            price: mapping?.supplier_price || 0,
                            supplierPrice: mapping?.supplier_price || 0,
                            supplierUnit: mapping?.supplier_unit || "",
                            supplierLinked: !!mapping,
                            conversionFactor: mapping ? parseFloat(mapping.unit_conversion) || 1 : 1,
                            total: (mapping?.supplier_price || 0) * (alert.reorder_qty || 1),
                          };
                        });
                        setProductRows(prev => [...prev.filter(r => r.productName), ...newRows]);
                        showMessage(`Added ${newRows.length} products from reorder alerts`);
                      }}
                      sx={{ borderRadius: 2, textTransform: "none", fontSize: 11, fontWeight: 600, borderColor: "#e2e8f0", color: "#d97706", "&:hover": { bgcolor: "#fffbeb", borderColor: "#fbbf24" } }}>
                      Auto Reorder
                    </Button>
                  </Tooltip>
                  <Tooltip title="AI suggests optimal purchase quantities based on forecast data">
                    <Button variant="outlined" size="small"
                      startIcon={aiSuggestLoading ? <CircularProgress size={14} /> : <AutoAwesomeIcon sx={{ fontSize: 15 }} />}
                      disabled={aiSuggestLoading}
                      onClick={async () => {
                        // Use supplier-linked product IDs if available, otherwise use existing rows
                        let productIds: number[];
                        if (supplierProductIds.size > 0) {
                          productIds = Array.from(supplierProductIds);
                        } else {
                          productIds = productRows.filter(r => r.productId).map(r => Number(r.productId));
                        }
                        if (productIds.length === 0) { showErrorMessage("No linked products found. Link products to supplier first."); return; }
                        setAiSuggestLoading(true);
                        try {
                          const res = await triggerForecast({ product_ids: productIds }).unwrap();
                          if (res?.data) {
                            const forecastData = res.data as Record<string, any>;
                            // Build rows from forecast data for linked products
                            const newRows: IProduct[] = [];
                            const existingPids = new Set(productRows.filter(r => r.productId).map(r => String(r.productId)));

                            Object.entries(forecastData).forEach(([pid, forecast]) => {
                              if (!forecast.reorder_qty || forecast.reorder_qty <= 0) return;
                              const mapping = supplierProductMap[Number(pid)];
                              // Only add supplier-linked products
                              if (supplierProductIds.size > 0 && !supplierProductIds.has(Number(pid))) return;

                              if (existingPids.has(pid)) {
                                // Update existing row
                                const row = productRows.find(r => String(r.productId) === pid);
                                if (row) {
                                  row.quantity = forecast.reorder_qty;
                                  row.baseQtyTotal = forecast.reorder_qty * (row.conversionFactor || 1);
                                  row.total = (row.price || 0) * forecast.reorder_qty;
                                  row.unitTotalWithDiscount = row.total;
                                }
                              } else {
                                // Add new row
                                const product = productList.find(p => String(p.id) === pid);
                                if (product) {
                                  newRows.push({
                                    ...emptyProductRow,
                                    productName: product.productName,
                                    productId: pid,
                                    quantity: forecast.reorder_qty,
                                    price: mapping?.supplier_price || 0,
                                    supplierPrice: mapping?.supplier_price || 0,
                                    supplierUnit: mapping?.supplier_unit || "",
                                    supplierLinked: !!mapping,
                                    conversionFactor: mapping ? parseFloat(mapping.unit_conversion) || 1 : 1,
                                    baseQtyTotal: forecast.reorder_qty * (mapping ? parseFloat(mapping.unit_conversion) || 1 : 1),
                                    total: (mapping?.supplier_price || 0) * forecast.reorder_qty,
                                    unitTotalWithDiscount: (mapping?.supplier_price || 0) * forecast.reorder_qty,
                                  });
                                }
                              }
                            });

                            const updated = [...productRows.filter(r => r.productName), ...newRows];
                            if (updated.length === 0) updated.push({ ...emptyProductRow });
                            setProductRows(updated);
                            showMessage(`AI applied: ${newRows.length} new + ${productRows.filter(r => r.productId).length} updated`);
                          }
                        } catch { showErrorMessage("Failed to fetch forecast data"); }
                        setAiSuggestLoading(false);
                      }}
                      sx={{ borderRadius: 2, textTransform: "none", fontSize: 11, fontWeight: 600, borderColor: "#e2e8f0", color: "#7c3aed", "&:hover": { bgcolor: "#f5f3ff", borderColor: "#a78bfa" } }}>
                      AI Suggest
                    </Button>
                  </Tooltip>
                  <Button variant="outlined" size="small"
                    startIcon={<LocalShippingIcon sx={{ fontSize: 15 }} />}
                    onClick={() => setReceiveDialogOpen(true)}
                    disabled={productRows.filter(r => r.productName).length === 0}
                    sx={{ borderRadius: 2, textTransform: "none", fontSize: 11, fontWeight: 600, borderColor: "#e2e8f0", color: "#16a34a", "&:hover": { bgcolor: "#f0fdf4", borderColor: "#86efac" } }}>
                    Receive Items
                  </Button>
                </Box>
              </Box>
                                    <TableContainer sx={{ borderRadius: 1.5, border: "1px solid #E5E7EB", overflow: "visible" }}>
                                      <Table size="small" sx={{ overflow: "visible" }}>
                                        <TableHead>
                                          <TableRow sx={{ bgcolor: "#F9FAFB" }}>
                                            {["Product", "Supplier Unit", "Conversion", "Qty", "Unit Cost", "Base Qty", "Total", ""].map(h => (
                                              <TableCell key={h} sx={{ fontWeight: 500, fontSize: 11, color: "#6B7280", py: 1.25, borderBottom: "1px solid #E5E7EB", ...(h === "" ? { textAlign: "right", width: 50 } : {}) }}>{h}</TableCell>
                                            ))}
                                          </TableRow>
                                        </TableHead>
                
                
                                        <TableBody>

          
    {productRows.map((product, index) => (
      <React.Fragment key={index}>
      <TableRow sx={{
        "&:hover": { bgcolor: "#F9FAFB" },
        bgcolor: highlightRow === index ? "#F0FDF4" : "inherit",
        transition: "background-color 0.5s ease",
      }}>
        {/* Product */}
        <TableCell sx={{ width: 280, position: "relative" }}
          onBlur={(e) => {
            // Only close if focus moves outside this cell entirely
            const cell = e.currentTarget;
            setTimeout(() => {
              if (!cell.contains(document.activeElement)) {
                setShowDropdownProductIndex(null);
              }
            }, 200);
          }}>
          <TextField
            size="small"
            fullWidth
            value={product.productName}
            onChange={(e) => handleProductNameChange(index, e.target.value)}
            placeholder="Search product..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ fontSize: 16, color: "#94a3b8" }} />
                </InputAdornment>
              ),
            }}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: 1.5, fontSize: 13, "& fieldset": { borderColor: "#E5E7EB" } } }}
            onFocus={() => setShowDropdownProductIndex(index)}
          />
          {/* Supplier link status */}
          {product.productName && product.productId && !product.supplierLinked && selectedCustomer && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
              <WarningAmberIcon sx={{ fontSize: 13, color: "#d97706" }} />
              <Typography sx={{ fontSize: 10, color: "#d97706", fontWeight: 600 }}>Not linked</Typography>
              <Typography component="span" onClick={() => {
                setLinkProduct({ id: String(product.productId), name: product.productName, index });
                setLinkForm({ supplier_price: product.price || 0, supplier_unit: product.supplierUnit || "", unit_conversion: "" });
                setLinkModalOpen(true);
              }}
                sx={{ fontSize: 10, color: "#2563eb", fontWeight: 700, cursor: "pointer", ml: 0.5, "&:hover": { textDecoration: "underline" } }}>
                Link now
              </Typography>
            </Box>
          )}
          {product.productName && product.productId && product.supplierLinked && selectedCustomer && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
              <CheckCircleIcon sx={{ fontSize: 13, color: "#16a34a" }} />
              <Typography sx={{ fontSize: 10, color: "#16a34a", fontWeight: 600 }}>Linked</Typography>
            </Box>
          )}

          {showDropdownProductIndex === index && (
            <Paper elevation={8}
              sx={{ width: 380, maxHeight: 320, position: "absolute", left: 0, top: "100%", zIndex: 9999, borderRadius: 2, border: "1px solid #E5E7EB", mt: 0.5 }}>
              <Box sx={{ px: 1.5, py: 1, borderBottom: "1px solid #f1f5f9", bgcolor: "#F9FAFB", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Typography sx={{ fontSize: 10, fontWeight: 600, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.06em" }}>
                  {(productIsLoading && directProductList.length === 0) || supplierProductsLoading ? "Loading..." : `${filteredProductList.length} products`}
                </Typography>
                {supplierProductIds.size > 0 && (
                  <Chip
                    label={supplierOnlyMode ? "Supplier Only" : "All Products"}
                    size="small"
                    onClick={(e) => { e.stopPropagation(); setSupplierOnlyMode(v => !v); }}
                    sx={{ height: 20, fontSize: 9, fontWeight: 700, cursor: "pointer",
                      bgcolor: supplierOnlyMode ? "#dcfce7" : "#f1f5f9",
                      color: supplierOnlyMode ? "#16a34a" : "#64748b",
                      "&:hover": { opacity: 0.8 } }}
                  />
                )}
              </Box>
              <Box sx={{ maxHeight: 230, overflowY: "auto" }}>
              {(productIsLoading && directProductList.length === 0) ? (
                <Box sx={{ textAlign: "center", py: 3 }}><CircularProgress size={20} sx={{ color: "#00838f" }} /></Box>
              ) : filteredProductList.length > 0 ? (
                filteredProductList.map((Product) => (
                  <MenuItem key={Product.id} onClick={() => handleProductSelect(Product, index)}
                    sx={{ py: 1, px: 1.5, fontSize: 13, gap: 1.5, borderBottom: "1px solid #F3F4F6",
                      borderLeft: supplierProductIds.has(Number(Product.id)) ? "3px solid #10B981" : "3px solid transparent",
                      "&:hover": { bgcolor: "#F9FAFB" } }}>
                    <Box sx={{ width: 32, height: 32, borderRadius: 1.5, bgcolor: "#f1f5f9", overflow: "hidden", flexShrink: 0 }}>
                      <img src={Product.productImg ? `${LARAVEL_API_URL}/${String(Product.productImg)}` : placeholderImage} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    </Box>
                    <Typography fontSize={13} fontWeight={500} color="#1e293b" sx={{ flex: 1, textTransform: "capitalize" }}>{Product.productName}</Typography>
                    {supplierProductIds.has(Number(Product.id)) && (
                      <Chip label="Linked" size="small" sx={{ height: 18, fontSize: 9, fontWeight: 700, bgcolor: "#dcfce7", color: "#16a34a" }} />
                    )}
                  </MenuItem>
                ))
              ) : (
                <Box sx={{ py: 3, textAlign: "center" }}><Typography fontSize={12} color="#94a3b8">No products match</Typography></Box>
              )}
              </Box>
            </Paper>
          )}
        </TableCell>

        {/* Supplier Unit */}
        <TableCell>
          <Chip size="small" label={product.supplierUnit || "—"}
            sx={{ height: 24, fontSize: 11, fontWeight: 600, bgcolor: product.supplierUnit ? "#eff6ff" : "#f1f5f9", color: product.supplierUnit ? "#2563eb" : "#94a3b8" }} />
        </TableCell>

        {/* Conversion Display */}
        <TableCell>
          {product.conversionFactor > 1 ? (
            <Tooltip title={`1 ${product.supplierUnit || "unit"} = ${product.conversionFactor} ${product.baseUnit}`}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <SwapHorizIcon sx={{ fontSize: 14, color: "#8b5cf6" }} />
                <Typography sx={{ fontSize: 11, fontWeight: 600, color: "#7c3aed" }}>
                  1 → {product.conversionFactor}
                </Typography>
              </Box>
            </Tooltip>
          ) : (
            <Typography sx={{ fontSize: 11, color: "#cbd5e1" }}>1:1</Typography>
          )}
        </TableCell>

        {/* Quantity */}
        <TableCell sx={{ width: 90 }}>
          <TextField
            size="small"
            type="number"
            value={product.quantity}
            onChange={(e) => {
              handleFieldChange(index, "quantity", Math.max(Number(e.target.value), 0));
              if (showRowErrors) setShowRowErrors(false);
            }}
            error={showRowErrors && !!rowErrors[index]?.quantity}
            helperText={showRowErrors && rowErrors[index]?.quantity ? rowErrors[index].quantity : ""}
            sx={{ width: 80, "& .MuiOutlinedInput-root": { borderRadius: 1.5, fontSize: 13, "& fieldset": { borderColor: showRowErrors && rowErrors[index]?.quantity ? "#DC2626" : "#E5E7EB" } }, "& .MuiFormHelperText-root": { fontSize: 9, mx: 0 } }}
          />
        </TableCell>

        {/* Unit Cost */}
        <TableCell sx={{ width: 100 }}>
          <TextField
            size="small"
            type="number"
            value={product.price || ""}
            onChange={(e) => {
              handleFieldChange(index, "price", Number(e.target.value));
              if (showRowErrors) setShowRowErrors(false);
            }}
            error={showRowErrors && !!rowErrors[index]?.price}
            helperText={showRowErrors && rowErrors[index]?.price ? rowErrors[index].price : ""}
            inputProps={{ min: 0 }}
            InputProps={{ startAdornment: <InputAdornment position="start" sx={{ "& .MuiTypography-root": { fontSize: 12, color: "#94a3b8" } }}>$</InputAdornment> }}
            sx={{ width: 100, "& .MuiOutlinedInput-root": { borderRadius: 1.5, fontSize: 13, "& fieldset": { borderColor: showRowErrors && rowErrors[index]?.price ? "#DC2626" : "#E5E7EB" } }, "& .MuiFormHelperText-root": { fontSize: 9, mx: 0 } }}
          />
        </TableCell>

        {/* Base Qty */}
        <TableCell>
          <Typography sx={{ fontSize: 13, fontWeight: 600, color: product.baseQtyTotal > 0 ? "#0f172a" : "#cbd5e1" }}>
            {product.baseQtyTotal > 0 ? product.baseQtyTotal.toFixed(1) : "—"}
          </Typography>
          {product.conversionFactor > 1 && product.quantity ? (
            <Typography sx={{ fontSize: 10, color: "#94a3b8" }}>
              {product.quantity} {product.supplierUnit} = {product.baseQtyTotal.toFixed(1)} {product.baseUnit}
            </Typography>
          ) : null}
        </TableCell>

        {/* Total */}
        <TableCell>
          <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#0f172a", fontVariantNumeric: "tabular-nums" }}>
            ${((product.price || 0) * (product.quantity || 0)).toFixed(2)}
          </Typography>
        </TableCell>

        {/* Actions */}
        <TableCell align="right">
          <IconButton size="small" onClick={() => handleDeleteRow(index)}
            sx={{ width: 28, height: 28, borderRadius: 1.5, border: "1px solid #e2e8f0", "&:hover": { bgcolor: "#fef2f2", borderColor: "#fca5a5" } }}>
            <FaTrash style={{ fontSize: 12, color: "#dc2626" }} />
          </IconButton>
        </TableCell>
      </TableRow>

    {/* Serialized Rows */}
  {product.isSerialize && (
    <TableRow>
      <TableCell colSpan={8} sx={{ p: 0, border: "none" }}>
        {/* Container for serialized items with heading */}
        <Box sx={{ pl: 5, pr: 1, py: 1, backgroundColor: "#f9f9f9", borderRadius: 1 }}>
          {/* Heading */}
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: "bold",
              mb: 1,
              color: "#333",
            }}
          >
            Serialized Items
          </Typography>

          {/* Serialized item rows */}
          {Array.from({ length: product.quantity || 0 }).map((_, sIndex) => (
            <Box key={`serial-${index}-${sIndex}`} display="flex" gap={1.5} mb={1}>
            <TextField
                size="small"
                placeholder="Serial Number"
                value={product.serializedItems?.[sIndex]?.serialNo || ""}
                onChange={(e) => updateSerial(index, sIndex, "serialNo", e.target.value)}
              />

              <TextField
                size="small"
                placeholder="IMEI"
                value={product.serializedItems?.[sIndex]?.imei || ""}
                onChange={(e) => updateSerial(index, sIndex, "imei", e.target.value)}
              />

              <TextField
              size="small"
              placeholder="Model No"
              value={product.serializedItems?.[sIndex]?.modelNo || ""}
              onChange={(e) => updateSerial(index, sIndex, "modelNo", e.target.value)}
            />

            <TextField
              size="small"
              placeholder="Notes"
              value={product.serializedItems?.[sIndex]?.notes || ""}
              onChange={(e) => updateSerial(index, sIndex, "notes", e.target.value)}
            />
          </Box>
        ))}
      </Box>
    </TableCell>
  </TableRow>
)}



</React.Fragment>
  ))}
</TableBody>

                      </Table>
                    </TableContainer>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", py: 2 }}>
                      {/* Validation status */}
                      {hasFilledRows && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                          {hasRowErrors ? (
                            <>
                              <ErrorIcon sx={{ fontSize: 14, color: "#DC2626" }} />
                              <Typography fontSize={11} color="#DC2626" fontWeight={600}>
                                {Object.keys(rowErrors).length} item{Object.keys(rowErrors).length > 1 ? "s" : ""} incomplete
                              </Typography>
                            </>
                          ) : (
                            <>
                              <CheckCircleIcon sx={{ fontSize: 14, color: "#059669" }} />
                              <Typography fontSize={11} color="#059669" fontWeight={600}>All items valid</Typography>
                            </>
                          )}
                        </Box>
                      )}
                      <Box sx={{ ml: "auto" }}>
                        <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={handleAddRow}
                          sx={{ borderRadius: 1.5, textTransform: "none", fontSize: 12, fontWeight: 600, borderColor: "#E5E7EB", color: "#374151", "&:hover": { bgcolor: "#F9FAFB" } }}>
                          Add Item
                        </Button>
                      </Box>
                    </Box>
          </Paper>

            {/* ── TOTALS SECTION ───────────────────────────────────── */}
          <Paper elevation={0} sx={{ p: 3, mb: 3, borderRadius: 2, border: "1px solid #E5E7EB" }}>
              <Grid container spacing={3}>
                {/* Discounts */}
                <Grid item xs={12} md={5}>
                  <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", mb: 1.5 }}>Discounts</Typography>
                  {discounts.map((discount, index) => (
                    <Box key={index} sx={{ display: "flex", gap: 1.5, mb: 1.5, alignItems: "center" }}>
                      <TextField
                        placeholder="Discount description"
                        size="small"
                        value={discount.description}
                        onChange={(e) => handleDiscountChange(index, "description", e.target.value)}
                        sx={{ flex: 2, "& .MuiOutlinedInput-root": { borderRadius: 1.5, fontSize: 13, "& fieldset": { borderColor: "#e2e8f0" } } }}
                      />
                      <TextField
                        placeholder="Amount"
                        size="small"
                        type="number"
                        value={discount.value}
                        onChange={(e) => handleDiscountChange(index, "value", Number(e.target.value))}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        }}
                        sx={{ flex: 1, "& .MuiOutlinedInput-root": { borderRadius: 1.5, fontSize: 13, "& fieldset": { borderColor: "#e2e8f0" } } }}
                      />
                      <IconButton size="small" onClick={() => handleOpenDialog(index)} sx={{ color: "#64748b" }}>
                        <FaEdit style={{ fontSize: 14 }} />
                      </IconButton>
                      <IconButton size="small" onClick={() => handleDeleteDiscount(index)} sx={{ color: "#ef4444" }}>
                        <FaTrash style={{ fontSize: 14 }} />
                      </IconButton>
                    </Box>
                  ))}
                  <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 1 }}>
                    <Button variant="outlined" size="small" startIcon={<AddIcon />} onClick={() => handleOpenDialog(null)}
                      sx={{ textTransform: "none", fontSize: 12, borderRadius: 2, borderColor: "#e2e8f0", color: "#64748b" }}>
                      Add Discount
                    </Button>
                  </Box>
                </Grid>

                {/* Inventory Impact */}
                <Grid item xs={12} md={3}>
                  <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", mb: 1.5 }}>Inventory Impact</Typography>
                  <Box sx={{ border: "1px solid #e2e8f0", borderRadius: 2, p: 2, bgcolor: "#F9FAFB" }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                      <Typography sx={{ fontSize: 12, color: "#64748b" }}>Total Supplier Units</Typography>
                      <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#0f172a" }}>
                        {productRows.reduce((sum, r) => sum + (r.quantity || 0), 0).toFixed(1)}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                      <Typography sx={{ fontSize: 12, color: "#64748b" }}>Total Base Units</Typography>
                      <Typography sx={{ fontSize: 13, fontWeight: 700, color: "#7c3aed" }}>
                        {productRows.reduce((sum, r) => sum + (r.baseQtyTotal || 0), 0).toFixed(1)}
                      </Typography>
                    </Box>
                    <Divider sx={{ my: 1 }} />
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                        <InventoryIcon sx={{ fontSize: 14, color: "#16a34a" }} />
                        <Typography sx={{ fontSize: 12, color: "#16a34a", fontWeight: 600 }}>Expected Stock Increase</Typography>
                      </Box>
                      <Typography sx={{ fontSize: 14, fontWeight: 800, color: "#16a34a" }}>
                        +{productRows.reduce((sum, r) => sum + (r.baseQtyTotal || 0), 0).toFixed(1)}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                {/* Summary */}
                <Grid item xs={12} md={4}>
                  <Typography sx={{ fontSize: 11, fontWeight: 700, color: "#64748b", textTransform: "uppercase", letterSpacing: "0.06em", mb: 1.5 }}>Order Summary</Typography>
                  <Box sx={{ border: "1px solid #e2e8f0", borderRadius: 2.5, overflow: "hidden" }}>
                    <Box sx={{ display: "flex", justifyContent: "space-between", px: 2.5, py: 1.5, borderBottom: "1px solid #f1f5f9" }}>
                      <Typography sx={{ fontSize: 13, color: "#94a3b8", fontWeight: 500 }}>Subtotal</Typography>
                      <Typography sx={{ fontSize: 14, fontWeight: 700, color: "#334155", fontVariantNumeric: "tabular-nums" }}>${subTotal.toFixed(2)}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", px: 2.5, py: 1.5, borderBottom: "1px solid #f1f5f9" }}>
                      <Typography sx={{ fontSize: 13, color: "#94a3b8", fontWeight: 500 }}>Discount</Typography>
                      <Typography sx={{ fontSize: 14, fontWeight: 700, color: totalDiscount > 0 ? "#ef4444" : "#334155", fontVariantNumeric: "tabular-nums" }}>
                        {totalDiscount > 0 ? "-" : ""}${totalDiscount.toFixed(2)}
                      </Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "space-between", px: 2.5, py: 2, borderTop: "2px solid #111827" }}>
                      <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#111827" }}>Grand Total</Typography>
                      <Typography sx={{ fontSize: 18, fontWeight: 700, color: "#111827", fontVariantNumeric: "tabular-nums" }}>
                        ${isNaN(grandTotalEithDiscount) ? "0.00" : (grandTotalEithDiscount ?? 0).toFixed(2)}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
          </Paper>

            {/* ── REMARKS ──────────────────────────────────────────── */}
          <Paper elevation={0} sx={{ p: 3, mb: 3, borderRadius: 2, border: "1px solid #E5E7EB" }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography variant="caption" sx={{ fontWeight: 600, color: "#64748b", mb: 0.5, display: "block" }}>
                    Remarks on PO
                  </Typography>
                  <TextField
                    placeholder="Notes visible on the purchase order..."
                    size="small"
                    multiline
                    rows={4}
                    fullWidth
                    {...formik.getFieldProps("quoteWorkOrderCustomerMemo")}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="caption" sx={{ fontWeight: 600, color: "#64748b", mb: 0.5, display: "block" }}>
                    Internal Notes
                  </Typography>
                  <TextField
                    placeholder="Internal notes (not shown to supplier)..."
                    size="small"
                    multiline
                    rows={4}
                    fullWidth
                    {...formik.getFieldProps("quoteWorkOrderCustomerRemark")}
                  />
                </Grid>
              </Grid>
          </Paper>

            {/* ── ACTION BUTTONS ────────────────────────────────────── */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, py: 3, borderTop: "1px solid #E5E7EB" }}>
                <Button variant="outlined" startIcon={<CloseIcon />} onClick={cancelFunction}
                  sx={{ borderRadius: 1.5, textTransform: "none", px: 3, fontWeight: 500, fontSize: 13, borderColor: "#D1D5DB", color: "#374151", "&:hover": { bgcolor: "#F9FAFB" } }}>
                  Cancel
                </Button>
                <Button variant="contained" disableElevation startIcon={<SaveAltIcon />} onClick={() => formik.handleSubmit()} disabled={!formValid || isLoading}
                  sx={{ borderRadius: 1.5, textTransform: "none", px: 4, fontWeight: 600, fontSize: 13, bgcolor: "#111827", "&:hover": { bgcolor: "#1F2937" }, "&.Mui-disabled": { bgcolor: "#E5E7EB", color: "#9CA3AF" } }}>
                  {isLoading ? <CircularProgress size={20} color="inherit" /> : "Save Purchase Order"}
                </Button>
          </Box>

          {/* ── EDIT PRODUCT DIALOG ─────────────────────────────────── */}
          <Dialog open={popupOpen} onClose={() => setPopupOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>{editIndex !== null ? "Edit Product" : "Add Product"}</DialogTitle>
            <DialogContent>
              <Grid container spacing={2.5} sx={{ pt: 1 }}>
                <Grid item xs={12}>
                  <Typography variant="caption" sx={{ fontWeight: 600, color: "#64748b", mb: 0.5, display: "block" }}>Product</Typography>
                  <TextField
                    size="small"
                    fullWidth
                    value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.productName}
                    onChange={(e) => handleProductNameChange(editIndex !== null ? editIndex : productRows.length - 1, e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"><SearchIcon sx={{ fontSize: 18, color: "#94a3b8" }} /></InputAdornment>
                      ),
                    }}
                    onFocus={() => setShowDropdownProductIndex(editIndex !== null ? editIndex : productRows.length - 1)}
                  />
                  {showDropdownProductIndex === (editIndex !== null ? editIndex : productRows.length - 1) && (
                    <Paper elevation={3} sx={{ maxHeight: 200, position: "absolute", zIndex: 20, width: "100%", borderRadius: 2, border: "1px solid #e2e8f0", overflow: "auto" }}>
                      {productIsLoading ? (
                        <Box sx={{ textAlign: "center", p: 2 }}><CircularProgress size={24} /></Box>
                      ) : (
                        productList.length > 0 && productList.map((Product) => (
                          <MenuItem key={Product.id} onClick={() => handleProductSelect(Product, editIndex !== null ? editIndex : productRows.length - 1)}>
                            <img src={Product.productImg ? `${LARAVEL_API_URL}/${String(Product.productImg)}` : placeholderImage} alt="img" style={{ width: 32, height: 32, borderRadius: 6, objectFit: "cover", marginRight: 8 }} />
                            {Product.productName}
                          </MenuItem>
                        ))
                      )}
                    </Paper>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="caption" sx={{ fontWeight: 600, color: "#64748b", mb: 0.5, display: "block" }}>Description</Typography>
                  <TextField
                    placeholder="Enter description..."
                    size="small"
                    multiline
                    rows={3}
                    fullWidth
                    value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.productDescription}
                    onChange={(e) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "productDescription", e.target.value)}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="caption" sx={{ fontWeight: 600, color: "#64748b", mb: 0.5, display: "block" }}>Quantity</Typography>
                  <TextField
                    size="small"
                    type="number"
                    fullWidth
                    value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.quantity}
                    onChange={(e) => handleFieldChange(editIndex !== null ? editIndex : productRows.length - 1, "quantity", Math.max(Number(e.target.value), 0))}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="caption" sx={{ fontWeight: 600, color: "#64748b", mb: 0.5, display: "block" }}>Unit Cost</Typography>
                  <TextField
                    size="small"
                    type="number"
                    fullWidth
                    value={productRows[editIndex !== null ? editIndex : productRows.length - 1]?.price || ""}
                    onChange={(e) => handlePriceChange(editIndex !== null ? editIndex : productRows.length - 1, Number(e.target.value))}
                    inputProps={{ min: "0" }}
                    InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
              <Button variant="outlined" startIcon={<CloseIcon />} onClick={handleCancel}>Cancel</Button>
              <Button
                variant="contained"
                startIcon={<SaveAltIcon />}
                onClick={() => {
                  if (editIndex !== null) {
                    const updatedRows = [...productRows];
                    updatedRows[editIndex] = productRows[editIndex];
                    setProductRows(updatedRows);
                  } else {
                    setProductRows([...productRows]);
                  }
                  setPopupOpen(false);
                }}
              >
                {editIndex !== null ? 'Update' : 'Save'}
              </Button>
            </DialogActions>
          </Dialog>

          {/* ── DISCOUNT DIALOG ──────────────────────────────────── */}
          <Dialog open={dialogOpen} onClose={handleCloseDialog} maxWidth="xs" fullWidth>
            <DialogTitle>Set Discount</DialogTitle>
            <DialogContent>
              <Grid container spacing={2.5} sx={{ pt: 1 }}>
                <Grid item xs={12}>
                  <Typography variant="caption" sx={{ fontWeight: 600, color: "#64748b", mb: 0.5, display: "block" }}>Amount</Typography>
                  <TextField
                    size="small"
                    type="number"
                    fullWidth
                    value={discountValue}
                    onChange={(e) => setDiscountValue(Number(e.target.value))}
                    InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="caption" sx={{ fontWeight: 600, color: "#64748b", mb: 0.5, display: "block" }}>Description</Typography>
                  <TextField
                    placeholder="Discount description..."
                    size="small"
                    multiline
                    rows={4}
                    fullWidth
                    value={discountDescription}
                    onChange={(e) => setDiscountDescription(e.target.value)}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
              <Button variant="outlined" onClick={handleCloseDialog}>Cancel</Button>
              <Button variant="contained" onClick={handleSaveDiscount}
                sx={{ borderRadius: 2, textTransform: "none", bgcolor: "#0f172a", "&:hover": { bgcolor: "#1e293b" } }}>Save</Button>
            </DialogActions>
          </Dialog>

          {openCompany && (
            <NewCompanyPopUp
              handleCloseDialog={() => setOpenCompany(false)}
              openModel={openCompany}
            />
          )}

                {openCustomer && (
            <NewCustomerPopUp
            handleCloseDialog={() => setOpenCustomer(false)}
              openModel={openCustomer}
               onSuccess={handleNewCustomerAdded}
            />
          )}

          {/* ── LINK PRODUCT TO SUPPLIER MODAL ──────────────────── */}
          <Dialog open={linkModalOpen} onClose={() => setLinkModalOpen(false)} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
            <Box sx={{ px: 3, py: 2, borderBottom: "1px solid #E5E7EB", display: "flex", alignItems: "center", gap: 2 }}>
              <Typography fontSize={15} fontWeight={600} color="#111827" sx={{ flex: 1 }}>Link Product to Supplier</Typography>
              <IconButton size="small" onClick={() => setLinkModalOpen(false)} sx={{ color: "#9CA3AF" }}>
                <CloseIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </Box>
            <Box sx={{ p: 3 }}>
              {linkProduct && (
                <Box sx={{ mb: 2.5, p: 1.5, borderRadius: 2, bgcolor: "#f8fafc", border: "1px solid #e2e8f0" }}>
                  <Typography fontSize={13} fontWeight={600} color="#1e293b" sx={{ textTransform: "capitalize" }}>{linkProduct.name}</Typography>
                  <Typography fontSize={11} color="#94a3b8">→ {selectedCustomer?.customerCompanyName || "Supplier"}</Typography>
                </Box>
              )}
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box>
                  <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#334155", mb: 0.75 }}>Supplier Price *</Typography>
                  <TextField fullWidth size="small" type="number" placeholder="0.00" value={linkForm.supplier_price || ""}
                    onChange={e => setLinkForm(f => ({ ...f, supplier_price: Number(e.target.value) }))}
                    InputProps={{ startAdornment: <InputAdornment position="start"><Typography fontSize={12} color="#94a3b8">$</Typography></InputAdornment> }}
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, "& fieldset": { borderColor: "#e2e8f0" } } }} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#334155", mb: 0.75 }}>Supplier Unit</Typography>
                  <TextField fullWidth size="small" placeholder="e.g. box, bag, crate" value={linkForm.supplier_unit}
                    onChange={e => setLinkForm(f => ({ ...f, supplier_unit: e.target.value }))}
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, "& fieldset": { borderColor: "#e2e8f0" } } }} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: 12, fontWeight: 600, color: "#334155", mb: 0.75 }}>Conversion Rate</Typography>
                  <TextField fullWidth size="small" placeholder="e.g. 1 box = 10 lb" value={linkForm.unit_conversion}
                    onChange={e => setLinkForm(f => ({ ...f, unit_conversion: e.target.value }))}
                    sx={{ "& .MuiOutlinedInput-root": { borderRadius: 2, "& fieldset": { borderColor: "#e2e8f0" } } }} />
                </Box>
              </Box>
            </Box>
            <Box sx={{ px: 3, py: 2, bgcolor: "#F9FAFB", borderTop: "1px solid #f1f5f9", display: "flex", gap: 1.5, justifyContent: "flex-end" }}>
              <Button variant="outlined" size="small" onClick={() => setLinkModalOpen(false)}
                sx={{ borderRadius: 2, textTransform: "none", fontSize: 12, fontWeight: 600, borderColor: "#e2e8f0", color: "#64748b" }}>Cancel</Button>
              <Button variant="contained" disableElevation size="small" disabled={linkSaving || !linkForm.supplier_price}
                onClick={async () => {
                  if (!linkProduct || !selectedCustomer) return;
                  setLinkSaving(true);
                  try {
                    const json = await linkProductToSupplier({
                      vendorId: String(selectedCustomer.id),
                      product_id: Number(linkProduct.id),
                      supplier_price: linkForm.supplier_price,
                      supplier_unit: linkForm.supplier_unit,
                      unit_conversion: linkForm.unit_conversion,
                      is_default: true,
                    }).unwrap();
                    if (json.status !== false) {
                      showMessage("Product linked to supplier");
                      // Update local state
                      await loadSupplierProducts();
                      // Update the row
                      const updated = [...productRows];
                      updated[linkProduct.index].supplierPrice = linkForm.supplier_price;
                      updated[linkProduct.index].supplierUnit = linkForm.supplier_unit;
                      updated[linkProduct.index].price = linkForm.supplier_price;
                      updated[linkProduct.index].supplierLinked = true;
                      const conv = parseFloat(linkForm.unit_conversion) || 1;
                      updated[linkProduct.index].conversionFactor = conv;
                      const qty = updated[linkProduct.index].quantity || 0;
                      updated[linkProduct.index].total = linkForm.supplier_price * qty;
                      updated[linkProduct.index].baseQtyTotal = qty * conv;
                      setProductRows(updated);
                      setLinkModalOpen(false);
                    } else showErrorMessage(json.message || "Failed to link");
                  } catch { showErrorMessage("Something went wrong"); }
                  finally { setLinkSaving(false); }
                }}
                sx={{ borderRadius: 2, textTransform: "none", fontSize: 12, fontWeight: 700, bgcolor: "#0f172a",
                  "&:hover": { bgcolor: "#1e293b" }, "&.Mui-disabled": { bgcolor: "#e2e8f0", color: "#94a3b8" } }}>
                {linkSaving ? <CircularProgress size={14} sx={{ color: "#fff" }} /> : "Link & Apply"}
              </Button>
            </Box>
          </Dialog>

          {/* ── RECEIVE ITEMS DIALOG ──────────────────────────────────── */}
          <Dialog open={receiveDialogOpen} onClose={() => setReceiveDialogOpen(false)} maxWidth="md" fullWidth>
            <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5, borderBottom: "1px solid #e2e8f0", pb: 2 }}>
              <LocalShippingIcon sx={{ color: "#16a34a" }} />
              <Box>
                <Typography fontSize={16} fontWeight={700} color="#0f172a">Receive Items</Typography>
                <Typography fontSize={12} color="#94a3b8">Enter received quantities. Stock will be updated automatically.</Typography>
              </Box>
            </DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
              <TableContainer sx={{ mt: 1 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ bgcolor: "#F9FAFB" }}>
                      <TableCell sx={{ fontWeight: 600, fontSize: 11, color: "#64748b" }}>Product</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: 11, color: "#64748b" }}>Ordered</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: 11, color: "#64748b" }}>Supplier Unit</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: 11, color: "#64748b" }}>Received Qty</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: 11, color: "#64748b" }}>Conversion</TableCell>
                      <TableCell sx={{ fontWeight: 600, fontSize: 11, color: "#64748b" }}>Base Qty Added</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {productRows.filter(r => r.productName).map((product, idx) => (
                      <TableRow key={idx}>
                        <TableCell>
                          <Typography fontSize={13} fontWeight={600} color="#0f172a">{product.productName}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography fontSize={13} color="#334155">{product.quantity || 0}</Typography>
                        </TableCell>
                        <TableCell>
                          <Chip size="small" label={product.supplierUnit || "unit"} sx={{ height: 22, fontSize: 11, fontWeight: 600, bgcolor: "#eff6ff", color: "#2563eb" }} />
                        </TableCell>
                        <TableCell>
                          <TextField
                            size="small"
                            type="number"
                            value={product.receivedQty || ""}
                            onChange={(e) => {
                              const updated = [...productRows];
                              const realIdx = productRows.indexOf(product);
                              updated[realIdx].receivedQty = Math.max(Number(e.target.value), 0);
                              setProductRows(updated);
                            }}
                            inputProps={{ min: 0 }}
                            sx={{ width: 90, "& .MuiOutlinedInput-root": { borderRadius: 1.5, fontSize: 13 } }}
                          />
                        </TableCell>
                        <TableCell>
                          <Typography fontSize={12} color="#7c3aed" fontWeight={600}>× {product.conversionFactor}</Typography>
                        </TableCell>
                        <TableCell>
                          <Typography fontSize={13} fontWeight={700} color="#16a34a">
                            +{((product.receivedQty || 0) * (product.conversionFactor || 1)).toFixed(1)}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box sx={{ mt: 2, p: 2, bgcolor: "#f0fdf4", borderRadius: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <InventoryIcon sx={{ color: "#16a34a", fontSize: 18 }} />
                  <Typography fontSize={13} fontWeight={600} color="#16a34a">Total base units to add to inventory</Typography>
                </Box>
                <Typography fontSize={18} fontWeight={800} color="#16a34a">
                  +{productRows.filter(r => r.productName).reduce((sum, r) => sum + ((r.receivedQty || 0) * (r.conversionFactor || 1)), 0).toFixed(1)}
                </Typography>
              </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2, borderTop: "1px solid #e2e8f0", gap: 1 }}>
              <Button variant="outlined" onClick={() => setReceiveDialogOpen(false)}
                sx={{ borderRadius: 2, textTransform: "none", borderColor: "#e2e8f0", color: "#64748b" }}>
                Cancel
              </Button>
              <Button variant="contained" disableElevation disabled={isReceiving}
                startIcon={isReceiving ? <CircularProgress size={16} color="inherit" /> : <LocalShippingIcon sx={{ fontSize: 16 }} />}
                onClick={async () => {
                  const items = productRows
                    .filter(r => r.productName && r.receivedQty > 0)
                    .map(r => ({
                      product_id: Number(r.productId),
                      received_qty: r.receivedQty,
                      conversion_factor: r.conversionFactor || 1,
                      supplier_unit: r.supplierUnit || "unit",
                    }));
                  if (items.length === 0) {
                    showErrorMessage("Enter received quantities first");
                    return;
                  }
                  try {
                    const res = await receiveStockMutation({
                      po_id: workOrderId,
                      po_number: formik.values.quoteWorkOrderNo,
                      items,
                    }).unwrap();
                    if ((res as any)?.success) {
                      showMessage(res.message || "Stock received successfully");
                      // Update status to Partially Received or Completed
                      const allReceived = productRows.filter(r => r.productName).every(r => (r.receivedQty || 0) >= (r.quantity || 0));
                      formik.setFieldValue("quoteWorkOrderStatus", allReceived ? POStatus.Completed : POStatus.PartiallyReceived);
                      setReceiveDialogOpen(false);
                    } else {
                      showErrorMessage("Failed to receive stock");
                    }
                  } catch {
                    showErrorMessage("Error receiving stock");
                  }
                }}
                sx={{ borderRadius: 2, textTransform: "none", fontWeight: 700, bgcolor: "#16a34a", "&:hover": { bgcolor: "#15803d" } }}>
                {isReceiving ? "Processing..." : "Confirm & Update Inventory"}
              </Button>
            </DialogActions>
          </Dialog>

        </form>
      </Box>
    </Box>
  );
};

export default Index;
